import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "dropdown actions dropleft",
    attrs: {
      "role": "group"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "dropdown-menu"
  }, _vm._l(_vm.rowActions.slice().map(x => {
    return x.evaluate(_vm.row);
  }), function (action, aIndex) {
    return _c('a', {
      key: aIndex,
      staticClass: "dropdown-item d-flex align-items-start",
      class: {
        disabled: action.disabled || _vm.locked
      },
      attrs: {
        "href": "#",
        "type": "button",
        "disabled": action.disabled || _vm.locked
      },
      on: {
        "click": e => {
          e.preventDefault();
          _vm.$emit('row-action', {
            index: _vm.rowIndex,
            row: _vm.row,
            name: action.name
          });
        }
      }
    }, [_c('span', {
      staticClass: "d-inline-block mr-2 text-center",
      staticStyle: {
        "min-width": "1.1rem"
      }
    }, [action.icon ? _c('i', {
      class: action.icon
    }) : _vm._e()]), _c('span', {
      staticClass: "flex-fill",
      domProps: {
        "innerHTML": _vm._s(action.reason ? action.reason : action.label)
      }
    })]);
  }), 0)]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('button', {
    staticClass: "btn icon",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fas fa-ellipsis-h"
  })]);
}];
export { render, staticRenderFns };